import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-[#241F1C] text-[#FAF8F5] pt-16 pb-12 border-t border-[#38322E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-[#38322E]">
          {/* Col 1: Brand & Bio */}
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-block group focus:outline-none transition-transform duration-200 hover:scale-105"
              aria-label="Overgaard Pattegrise Forside"
            >
              <span className="text-xl sm:text-2xl font-bold tracking-tight text-white group-hover:text-white transition-colors">
                Overgaard Pattegrise
              </span>
            </Link>

            <p className="text-sm text-[#DDD5C9] leading-relaxed">
              Helstegt pattegris og velsmagende grill catering til din fest.
            </p>

            <div className="pt-2">
              <a
                href="https://www.instagram.com/overgaard_pattegris?vrfl=MXB0NmY0Z3pkeDZ1bA%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 text-sm text-[#FAF8F5] hover:text-[#C25E27] transition-colors group"
                aria-label="Følg Overgaard Pattegrise på Instagram"
              >
                <span className="w-8 h-8 rounded-full bg-[#38322E] group-hover:bg-[#C25E27] flex items-center justify-center transition-colors">
                  <i className="fa-brands fa-instagram text-base text-white" aria-hidden="true" />
                </span>
                <span>Følg os på Instagram</span>
              </a>
            </div>
          </div>

          {/* Col 2: Navigation Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-[#FAF8F5] mb-4">
              Maden &amp; Menuerne
            </h3>
            <ul className="space-y-2.5 text-sm text-[#DDD5C9]">
              <li>
                <Link to="/helstegt-pattegris" className="hover:text-[#C25E27] transition-colors">
                  Helstegt pattegris
                </Link>
              </li>
              <li>
                <Link to="/catering" className="hover:text-[#C25E27] transition-colors">
                  Grill catering til festen
                </Link>
              </li>
              <li>
                <Link to="/mad-ud-af-huset" className="hover:text-[#C25E27] transition-colors">
                  Mad ud af huset &amp; stegebuffet
                </Link>
              </li>
              <li>
                <Link to="/fest-og-udlejning" className="hover:text-[#C25E27] transition-colors">
                  Fest og udlejning (Softice, Slushice m.m.)
                </Link>
              </li>
              <li>
                <Link to="/bestil" className="hover:text-[#C25E27] transition-colors font-semibold text-[#C25E27]">
                  Sammensæt menu online →
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Information & Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-[#FAF8F5] mb-4">
              Virksomheden
            </h3>
            <ul className="space-y-2.5 text-sm text-[#DDD5C9]">
              <li>
                <Link to="/om-os" className="hover:text-[#C25E27] transition-colors">
                  Om Overgaard Pattegrise
                </Link>
              </li>
              <li>
                <Link to="/salgs-og-leveringsbetingelser" className="hover:text-[#C25E27] transition-colors">
                  Salgs- og leveringsbetingelser
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#C25E27] transition-colors">
                  Kontakt og forespørgsel
                </Link>
              </li>
            </ul>

            <div className="mt-6 pt-4 border-t border-[#38322E]">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-[#A89E96] mb-2">
                Telefontider
              </h4>
              <p className="text-xs text-[#DDD5C9] leading-relaxed">
                Hverdage kl. 15.00 – 19.00<br />
                Weekend &amp; helligdage kl. 10.00 – 14.00
              </p>
            </div>
          </div>

          {/* Col 4: Contact Info (Strict adherence to prompt requirements) */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-[#FAF8F5] mb-4">
              Kontaktoplysninger
            </h3>
            <div className="space-y-3 text-sm text-[#DDD5C9]">
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-white mt-1 text-sm" aria-hidden="true" />
                <div>
                  <span className="font-semibold text-[#FAF8F5] block">Overgaard Pattegrise</span>
                  <span>Simmelbrovej 52</span><br />
                  <span>7260 Sønder Omme</span>
                </div>
              </div>

              <div className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-white text-sm" aria-hidden="true" />
                <a
                  href="tel:25752724"
                  className="hover:text-white transition-colors font-medium whitespace-nowrap"
                >
                  25 75 27 24
                </a>
              </div>

              <div className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-white text-sm" aria-hidden="true" />
                <a
                  href="mailto:toemrerovergaardbyg@gmail.com"
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  toemrerovergaardbyg@gmail.com
                </a>
              </div>

              <div className="flex items-center gap-2.5 pt-1">
                <i className="fa-brands fa-instagram text-white text-sm" aria-hidden="true" />
                <a
                  href="https://www.instagram.com/overgaard_pattegris?vrfl=MXB0NmY0Z3pkeDZ1bA%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  @overgaard_pattegris
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#A89E96]">
          <p>© {new Date().getFullYear()} Overgaard Pattegrise • CVR: 45834719. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-6">
            <Link to="/salgs-og-leveringsbetingelser" className="hover:text-[#FAF8F5] transition-colors">
              Handelsbetingelser
            </Link>
            <Link to="/kontakt" className="hover:text-[#FAF8F5] transition-colors">
              Kontakt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
